import React from 'react';
import {COLUMN_NAMES} from './constants';
import {PurchaseRequest} from '../models/PurchaseRequest';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {Tooltip} from '@mui/material';
import {sortDirection} from '../components/ListOfPREditors.brick.jsx';
import {formatMaterialName} from "./helpers";

export const COLUMN_HEADER_CONFIG = [
    {
        name: COLUMN_NAMES.COMPANY_CODE,
        xs: 1,
        sx: {},
        content: (props) => COLUMN_NAMES.COMPANY_CODE,
    },
    {
        name: COLUMN_NAMES.EASY_REQUEST_PR_ID,
        xs: 1.4,
        sx: {},
        content: (props) => COLUMN_NAMES.EASY_REQUEST_PR_ID,
    },
    {
        name: COLUMN_NAMES.SAP_PR_NUMBER,
        xs: 1.8,
        sx: {},
        content: (props) => COLUMN_NAMES.SAP_PR_NUMBER,
        tab: (currentTab) => currentTab === PurchaseRequest.tab.submitted,
    },
    {
        name: COLUMN_NAMES.STATUS,
        xs: 2,
        sx: {},
        content: (props) => COLUMN_NAMES.STATUS,
    },
    {
        name: COLUMN_NAMES.FROM,
        xs: 1,
        sx: {},
        content: (props) => COLUMN_NAMES.FROM,
    },
    {
        name: COLUMN_NAMES.SPENDER,
        xs: 1,
        sx: {},
        content: (props) => COLUMN_NAMES.SPENDER,
    },
    {
        name: COLUMN_NAMES.REQUESTER,
        xs: 1,
        sx: {},
        content: (props) => COLUMN_NAMES.REQUESTER,
    },
    {
        name: COLUMN_NAMES.CREATION_DATE,
        xs: 1.4,
        sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
        },
        content: (props) => (
            <div style={{display: 'flex', alignItems: 'center'}}>
                <div style={{marginLeft: '0.3rem'}}>{COLUMN_NAMES.CREATION_DATE}</div>
                <div onClick={() => props.handleSort(props.sortKey.CREATION_DATE, getOppositeSortDirection(props.sortConfig.direction))} style={{marginLeft: '5px'}}>
                    {props.sortConfig.key === props.sortKey.CREATION_DATE && props.sortConfig.direction === props.sortDirection.DESCENDING && (
                        <KeyboardArrowDownIcon sx={{cursor: 'pointer'}} />
                    )}
                    {props.sortConfig.key === props.sortKey.CREATION_DATE && props.sortConfig.direction !== props.sortDirection.DESCENDING && (
                        <KeyboardArrowUpIcon sx={{cursor: 'pointer'}} />
                    )}
                    {props.sortConfig.key !== props.sortKey.CREATION_DATE && (
                        <KeyboardArrowDownIcon sx={{cursor: 'pointer', opacity: 0.5}} />
                    )}
                </div>
            </div>
        ),
    },
    {
        name: COLUMN_NAMES.SUBMISSION_DATE,
        xs: 1.6,
        sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
        },
        content: (props) => (
            <div style={{display: 'flex', alignItems: 'center'}}>
                <div style={{marginLeft: '0.3rem'}}>{COLUMN_NAMES.SUBMISSION_DATE}</div>
                <div onClick={() => props.handleSort(props.sortKey.SUBMISSION_DATE, getOppositeSortDirection(props.sortConfig.direction))} style={{marginLeft: '5px'}}>
                    {props.sortConfig.key === props.sortKey.SUBMISSION_DATE && props.sortConfig.direction === props.sortDirection.DESCENDING && (
                        <KeyboardArrowDownIcon sx={{cursor: 'pointer'}} />
                    )}
                    {props.sortConfig.key === props.sortKey.SUBMISSION_DATE && props.sortConfig.direction !== props.sortDirection.DESCENDING && (
                        <KeyboardArrowUpIcon sx={{cursor: 'pointer'}} />
                    )}
                    {props.sortConfig.key !== props.sortKey.SUBMISSION_DATE && (
                        <KeyboardArrowDownIcon sx={{cursor: 'pointer', opacity: 0.5}} />
                    )}
                </div>
            </div>
        ),
    },
    {
        name: COLUMN_NAMES.TITLE,
        xs: 2,
        sx: {},
        content: (props) => COLUMN_NAMES.TITLE,
    },
    {
        name: COLUMN_NAMES.SUPPLIER,
        xs: 1.5,
        sx: {},
        content: (props) => COLUMN_NAMES.SUPPLIER,
    },
    {
        name: COLUMN_NAMES.CATEGORY,
        xs: 1,
        sx: {},
        content: (props) => COLUMN_NAMES.CATEGORY,
    },
    {
        name: COLUMN_NAMES.MATERIAL,
        xs: 1,
        sx: {},
        content: (props) => COLUMN_NAMES.MATERIAL,
    },
];

export const COLUMN_CONTENT_CONFIG = [
    {
        name: COLUMN_NAMES.COMPANY_CODE,
        xs: 1,
        sx: {},
        content: (props) => props.addTextWithTooltip(props.companyCode.label, props.companyCode.value),
    },
    {
        name: COLUMN_NAMES.EASY_REQUEST_PR_ID,
        xs: 1.4,
        sx: {},
        content: (props) => (
            <Tooltip
                title={props.copyToClipboardText}
                placement={'top'}
                arrow
                PopperProps={{
                    disablePortal: true,
                }}
                enterDelay={500}
                enterNextDelay={500}
                leaveDelay={props.copyToClipboardLeaveTime}
                TransitionProps={{onTransitionEnd: () => {
                    props.setCopyToClipboardText(`Copy PR's ID`);
                    props.setCopyToClipboardLeaveTime(0);
                }}}
            >
                <div onClick={(e) => props.copyToClipboard(e, 'EPR-' + (props.EPRId || props.tagToDisplayER(props.prTag)), props.setCopyToClipboardText('Copied'))}>
                    {'EPR-'}<br/>{props.EPRId || props.tagToDisplayER(props.prTag)}
                </div>
            </Tooltip>
        ),
    },
    {
        name: COLUMN_NAMES.SAP_PR_NUMBER,
        xs: 1.8,
        sx: {},
        content: (props) => props.currentTab === 'submitted requests' && (
            <Tooltip
                title={props.copyToClipboardTextPrNumber}
                placement={'top'}
                arrow
                PopperProps={{
                    disablePortal: true,
                }}
                enterDelay={500}
                enterNextDelay={500}
                leaveDelay={props.copyToClipboardLeaveTime}
                TransitionProps={{onTransitionEnd: () => {
                    props.setCopyToClipboardTextPrNumber(`Copy PR's number`);
                    props.setCopyToClipboardLeaveTime(0);
                }}}
            >
                <div onClick={(e) => props.copyToClipboard(e, props.prNumber, props.setCopyToClipboardTextPrNumber('Copied'))}>
                    {props.prNumber}
                </div>
            </Tooltip>
        ),
        tab: (currentTab) => currentTab === PurchaseRequest.tab.submitted,
    },
    {
        name: COLUMN_NAMES.STATUS,
        xs: 2,
        sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        content: (props) => props.addStatusIcon(),
    },
    {
        name: COLUMN_NAMES.FROM,
        xs: 1,
        sx: {},
        content: (props) => props.addTextWithTooltipMultiLines(props.sourceToDisplay || props.getStringValueForSourceFromApiKey(props.source, props.sourceFromApiKey)),
    },
    {
        name: COLUMN_NAMES.SPENDER,
        xs: 1,
        sx: {},
        content: (props) => props.addAvatar(props.spender),
    },
    {
        name: COLUMN_NAMES.REQUESTER,
        xs: 1,
        sx: {},
        content: (props) => props.addAvatar(props.requester),
    },
    {
        name: COLUMN_NAMES.CREATION_DATE,
        xs: 1.4,
        sx: {},
        content: (props) => props.readableDate,
    },
    {
        name: COLUMN_NAMES.SUBMISSION_DATE,
        xs: 1.6,
        sx: {},
        content: (props) => props.submissionDate && (<>{props.submissionDate.toLocaleString('en-US', props.readableDateOptions)}</>),
    },
    {
        name: COLUMN_NAMES.TITLE,
        xs: 2,
        sx: {},
        content: (props) => props.addTextWithTooltipMultiLines(props.projectTitle),
    },
    {
        name: COLUMN_NAMES.SUPPLIER,
        xs: 1.5,
        sx: {},
        content: (props) => (
            <div style={{display: 'inline-flex', alignItems: 'center', justifyContent: 'center'}}>
                {props.addTextWithTooltip(`${props.vendorCode} - ${props.vendorName}`, props.vendorCode)}
                {props.addSupplierButton()}
            </div>
        ),
    },
    {
        name: COLUMN_NAMES.CATEGORY,
        xs: 1,
        sx: {},
        content: (props) => props.l1Category && props.addTextWithTooltip(props.l1Category, props.l1Category.split(' - ')[0]),
    },
    {
        name: COLUMN_NAMES.MATERIAL,
        xs: 1,
        sx: {},
        content: (props) => (
            <Tooltip
                id='materials-tooltip-popper'
                title={
                    <div onClick={(e) => e.stopPropagation()} className={'pr-editor-material-tooltip-names'}>
                        {props.materials.map((mat, idx) => (
                            <div className={'pr-editor-material-name-tooltip'} key={idx}>
                                {formatMaterialName(mat.name)}
                            </div>
                        ))}
                    </div>
                }
            >
                <div style={{fontStyle: 'italic'}}> {`${props.materials.length} item${props.materials.length > 1 ? 's' : ''}`} </div>
            </Tooltip>
        ),
    },
];

/**
 * Returns the opposite sort direction
 * @param {string} direction
 * @return {string}
 */
const getOppositeSortDirection = (direction) => {
    return direction === sortDirection.ASCENDING ? sortDirection.DESCENDING : sortDirection.ASCENDING;
};

